var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconHelpcenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.3335 6.70825C5.3335 5.2355 6.52741 4.04159 8.00016 4.04159C9.47292 4.04159 10.6668 5.2355 10.6668 6.70825C10.6668 7.95081 9.81698 8.99488 8.66683 9.29091V10.0416C8.66683 10.4098 8.36835 10.7083 8.00016 10.7083C7.63197 10.7083 7.3335 10.4098 7.3335 10.0416V8.70825C7.3335 8.34006 7.63197 8.04159 8.00016 8.04159C8.73654 8.04159 9.3335 7.44463 9.3335 6.70825C9.3335 5.97188 8.73654 5.37492 8.00016 5.37492C7.26379 5.37492 6.66683 5.97188 6.66683 6.70825C6.66683 7.07644 6.36835 7.37492 6.00016 7.37492C5.63197 7.37492 5.3335 7.07644 5.3335 6.70825Z",
    fill: "#FDFDFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.8335 12.2083C8.8335 12.6685 8.4604 13.0416 8.00016 13.0416C7.53993 13.0416 7.16683 12.6685 7.16683 12.2083C7.16683 11.748 7.53993 11.3749 8.00016 11.3749C8.4604 11.3749 8.8335 11.748 8.8335 12.2083Z",
    fill: "#FDFDFD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.3335 3.49992C1.3335 2.57945 2.07969 1.83325 3.00016 1.83325H13.0002C13.9207 1.83325 14.6668 2.57945 14.6668 3.49992V13.4999C14.6668 14.4204 13.9207 15.1666 13.0002 15.1666H3.00016C2.0797 15.1666 1.3335 14.4204 1.3335 13.4999V3.49992ZM3.00016 3.16659C2.81607 3.16659 2.66683 3.31583 2.66683 3.49992V13.4999C2.66683 13.684 2.81606 13.8333 3.00016 13.8333H13.0002C13.1843 13.8333 13.3335 13.684 13.3335 13.4999V3.49992C13.3335 3.31582 13.1843 3.16659 13.0002 3.16659H3.00016Z",
    fill: "#FDFDFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHelpcenter);
export default __webpack_public_path__ + "static/media/icon-helpcenter.b901671c461d73b02cff0d60689b8842.svg";
export { ForwardRef as ReactComponent };